module.exports = __webpack_public_path__ + "static/img/JA.77f3461.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/userTips/JA.png
// module id = wzi2
// module chunks = 1